import { createSlice } from '@reduxjs/toolkit';

const organizerSettingsSlice = createSlice({
    name: 'organizerSettings',
    initialState: {
        operation: 'organize', // 'organize' or 'appendNames'
        // Genre-first matches how DJs browse (genre → era), and became viable
        // once style grouping stopped landing everything in Uncategorized.
        mainOrganization: 'style', // 'releaseDate' or 'style'
        secondaryOrganization: 'releaseDate', // 'releaseDate', 'style', 'label', or 'none'
        tertiaryOrganization: 'none', // 'releaseDate', 'style', 'label', or 'none'
        includeMonth: false, // for organizeTracks
        dateFormat: 'year', // 'fullDate', 'monthAndYear', 'year'
        appendToBeginning: false, // for appendFileNames
    },
    reducers: {
        setOperation: (state, action) => {
            state.operation = action.payload;
        },
        setMainOrganization: (state, action) => {
            state.mainOrganization = action.payload;
        },
        setSecondaryOrganization: (state, action) => {
            state.secondaryOrganization = action.payload;
        },
        setTertiaryOrganization: (state, action) => {
            state.tertiaryOrganization = action.payload;
        },
        setIncludeMonth: (state, action) => {
            state.includeMonth = action.payload;
        },
        setDateFormat: (state, action) => {
            state.dateFormat = action.payload;
        },
        setAppendToBeginning: (state, action) => {
            state.appendToBeginning = action.payload;
        },
        // Merge persisted settings loaded from localStorage at startup
        // (whitelisted subset — see settingsPersistenceConfig).
        hydrate: (state, action) => {
            Object.assign(state, action.payload || {});
        },
    },
});

export const {
    setOperation,
    setMainOrganization,
    setSecondaryOrganization,
    setTertiaryOrganization,
    setIncludeMonth,
    setDateFormat,
    setAppendToBeginning,
    hydrate,
} = organizerSettingsSlice.actions;

export default organizerSettingsSlice.reducer;
